import React from 'react';
import PropTypes from 'prop-types';
import FlagIconFactory from 'react-flag-icon-css';
import './_styles_/FlagIcon.css';
import { joinClassNames } from '../utils';

const BaseFlagIcon = FlagIconFactory(React, { useCssModules: false });

FlagIcon.propTypes = {
    className: PropTypes.string,
};

FlagIcon.defaultProps = {
    className: null,
};

function FlagIcon(props) {
    const {
        className,
        ...rest
    } = props;
    return <BaseFlagIcon {...rest} className={joinClassNames('flag-icon--rounded-flag', className)} />;
}

export default FlagIcon;
